import React, { useEffect, useState } from 'react';
import { FcLikePlaceholder } from 'react-icons/fc';
import { RiDeleteBinLine, RiEdit2Line } from 'react-icons/ri';
import { end_points } from '@/services/endpoints';
import { getData, deleteData } from '@/services/api.service';
import AddEditAddressForm from './addEditAddressForm';
import Spinner from './spinner';

const MyAddress = () => {
  const [address, setAddress] = useState([]);
  const [editAddress, setEditAddress] = useState(null);
  const [loading, setLoading] = useState(true);

  const getAddress = async () => {
    setLoading(true);
    try {
      const response = await getData(end_points.address.url);
      setAddress(response?.data?.addresses);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    getAddress();
    
  }, []);

  const handleDelete = async (id) => {
    try {
      const response = await deleteData(
        `${end_points.address.delete_addres}/${id}`
      );
      if (response?.status == 200) {
        toaster.success('Address deleted successfully');
        getAddress();
      }
    } catch (error) {
      console.error('Error deleting address:', error);
    }
  };

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <div className="col-md-9 tabs style1">
          <div className="row">
            <div className="col-md-12">
              <div className="user-dashboard-tab__content tab-content">
                <div className="tab-pane fade show active" id="addresses">
                  <div className="card-box">
                    <p>
                      The following addresses will be used on the checkout page.
                    </p>
                    <AddEditAddressForm
                      setEditAddress={setEditAddress}
                      editAddress={editAddress}
                      getAddress={getAddress}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Existing Addresses */}
            {address?.map((addr) => (
              <div className="col-md-6" key={addr.id}>
                <div className="card address-card mb-4 default-address test">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                      <h5>{addr.name}</h5>
                      <div>
                        {/* <button
                      className={`btn btn-sm favorite ${addr.default ? '' : 'disabled'}`}
                    >
                      <FcLikePlaceholder />
                    </button> */}
                        <button
                          type="button"
                          className="btn btn-sm edit"
                          onClick={() => setEditAddress(addr)}
                        >
                          <RiEdit2Line />
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm delete"
                          onClick={() => handleDelete(addr.id)}
                        >
                          <RiDeleteBinLine />
                        </button>
                      </div>
                    </div>
                    <p>{addr.phone}</p>
                    <p>{addr.address}</p>
                    <p>{addr.city}</p>
                    <p>{addr.state}</p>
                    <p>
                      {addr.country}, {addr.zip}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default MyAddress;
